interface doItES {
  title_section: string;
  we_are_title: string;
  we_are_desc_1_1: string;
  we_are_desc_1_2: string;
  our_mission_title: string;
  our_mission_desc: string;
  our_vision_title: string;
  our_vision_desc: string;
}

export const doItES: doItES = {
  title_section: "HAZLO BIEN. HAZLO RÁPIDO. HAZLO.",
  we_are_title: "NOSOTROS SOMOS",
  we_are_desc_1_1:
    "Una firma de consultoría boutique especializada en esfuerzos de transformación personalizados basados en los principios Lean, a la que hemos denominado ",
  we_are_desc_1_2: "Impetus.",
  our_mission_title: "NUESTRA MISIÓN",
  our_mission_desc:
    "Somos el agente clave para implementar la mentalidad y los hábitos de Excelencia Operacional en la práctica diaria de nuestros clientes.",
  our_vision_title: "NUESTRA VISIÓN",
  our_vision_desc:
    "Ser el aliado estratégico de nuestros clientes para identificar, desarrollar y mejorar su valor en su industria y más allá.",
};

interface ourValuesES {
  title_section: string;
  respect: string;
  respect_desc: string;
  self_control: string;
  self_control_desc: string;
  wisdom: string;
  wisdom_desc: string;
  responsibility: string;
  responsibility_desc: string;
  honesty: string;
  honesty_desc: string;
}

export const ourValuesES: ourValuesES = {
  title_section: "OUR VALUES",
  respect: "Respeto:",
  respect_desc:
    "Teníamos en cuenta la dignidad, la situación actual, los méritos y los valores de nuestros clientes.",
  self_control: "Autocontrol:",
  self_control_desc:
    "Creemos en la virtud de controlar nuestros impulsos y emociones.",
  wisdom: "Sabiduría:",
  wisdom_desc:
    "Utilizamos nuestro conocimiento y experiencias para el mejora de las actividades de la sociedad.",
  responsibility: "Responsabilidad:",
  responsibility_desc:
    "Nos hacemos responsables de nuestras decisiones y asumimos todas las consecuencias.",
  honesty: "Honestidad:",
  honesty_desc:
    "Creemos en las virtudes de la dignidad, la sinceridad, la confianza y la seguridad.",
};

interface ourStoryES {
  title_section: string;
  card_2016_year: string;
  card_2016_title: string;
  card_2016_desc_1_1: string;
  card_2016_desc_1_2: string;
  card_2017_year: string;
  card_2017_desc_1_1: string;
  card_2017_desc_1_2: string;
  card_2017_desc_1_3: string;
  card_2017_desc_1_4: string;
  card_2017_desc_2_1: string;
  card_2017_desc_2_2: string;
  card_2017_desc_2_3: string;
  card_2017_desc_2_4: string;
  card_2017_desc_3: string;
  card_2017_desc_4_1: string;
  card_2017_desc_4_2: string;
  card_2017_desc_4_3: string;
  card_2018_year: string;
  card_2018_title: string;
  card_2018_desc_1_1: string;
  card_2018_desc_1_2: string;
  card_2019_year: string;
  card_2019_desc_1_1: string;
  card_2019_desc_1_2: string;
  card_2019_desc_1_3: string;
  card_2019_desc_1_4: string;
  card_2019_desc_1_5: string;

  card_2024_year: string;
  card_2024_title: string;
  card_2024_desc_1_1: string;
  card_2024_desc_1_2: string;
  card_2024_desc_1_3: string;
  card_2024_desc_1_4: string;
  card_2024_desc_1_5: string;
  card_2024_desc_1_6: string;
  card_2024_desc_1_7: string;
  image_mx: string;
  image_us: string;
}

export const ourStoryES: ourStoryES = {
  title_section: "NUESTRA HISTORIA",
  card_2016_year: "2016",
  card_2016_title: "GBCI Group inicia operaciones.",
  card_2016_desc_1_1: `Identificamos varias opciones para implementar la Excelencia Operacional y decidimos denominarlas `,
  card_2016_desc_1_2: `“Impetus.”`,
  card_2017_year: "2017",
  card_2017_desc_1_1: "Introducimos ",
  card_2017_desc_1_2: "Impetus",
  card_2017_desc_1_3: ", que incluye:",
  card_2017_desc_1_4:
    "Mejora Continua, Gestión Diaria, Innovación, Transformación y Automatización de Procesos.",

  card_2017_desc_2_1: "GBCI Group lanzó ",
  card_2017_desc_2_2: "Impetus Selection Assessment",
  card_2017_desc_2_3: ", que anteriormente se conocía como la",
  card_2017_desc_2_4:
    "Herramienta de Selección del Viaje hacia la Excelencia Operacional.",

  card_2017_desc_3:
    "¿Tienes curiosidad sobre cómo seleccionar el Impetus adecuado?",

  card_2017_desc_4_1:
    "Además de nuestro apoyo a los clientes, también ofrecemos ",
  card_2017_desc_4_2: "coaching ejecutivo ",
  card_2017_desc_4_3: "como un servicio oficial.",

  card_2018_year: "2018",
  card_2018_title: "GBCI Group se expandió.",
  card_2018_desc_1_1: "Paticipamos en el ",
  card_2018_desc_1_2: "North America Executive Committee Lean Training.",

  card_2019_year: "2019",
  card_2019_desc_1_1: "Durante la ",
  card_2019_desc_1_2: "pandemia de COVID-19",
  card_2019_desc_1_3: ", utilizando nuestro ",
  card_2019_desc_1_4: "Impetus de Automatización de Procesos",
  card_2019_desc_1_5:
    ", pudimos ayudar a nuestros clientes a implementar operaciones digitales.",

  card_2024_year: "2024",
  card_2024_title: "Apertura de la oficina en México.",
  card_2024_desc_1_1: "Hemos comenzado el desarrollo de nuestra plataforma de ",
  card_2024_desc_1_2: "Mejora Continua ",
  card_2024_desc_1_3: "por medio de la ",
  card_2024_desc_1_4: "aplicación Impetus ",
  card_2024_desc_1_5: "y lanzamos la ",
  card_2024_desc_1_6: "División de Juegos Digitales ",
  card_2024_desc_1_7: "de GBCI Group.",

  image_mx: "Oficina en Tampico, Tamaulipas, MX",
  image_us: "Oficina en Houston, Texas, EE. UU.",
};
